import { Routes, Route } from 'react-router-dom';
import {
  validAdminsRoles,
  validSuperAndSpecialAdminsRoles,
} from '@shared/constants';
import { Login } from '@/pages/Login/Login';
import McpAuth from '@/pages/McpAuth/McpAuth';
import { Files } from '@/pages/Files';
import { UsersList } from '@/pages/UsersList';
import { Settings } from '@/pages/Settings';
import MyAccount from '@/pages/MyAccount/MyAccount';
import { APISample } from '@/pages/APISample';
import { QBOAccessCallback } from '@/pages/QBOAccessCallback';
import Referral from '@/pages/Referral/Referral';
import { Logout } from '@/pages/Logout/Logout';
import Home from '@/pages/Home/Home';
import { ClientList } from '@/pages/ClientList';
import CustomTabUrl from '@/pages/CustomTabUrl/CustomTabUrl';
import MagicLoginCallback from '@/pages/Login/MagicLoginCallback';
import ProtectedRoute from '@/components/ProtectedRoute/ProtectedRoute';
import NavigateToDefaultPath from '@/components/ProtectedRoute/NavigateToDefaultPath';
import AccountInvestor from '@/pages/InvestorAccount/AccountInvestor';
import { FAQPage } from '@/pages/FAQ/FAQPage';
import MarketPlace from '@/pages/Marketplace/MarketPlace';
import { TaskpaneLink } from '@/pages/TaskpaneLink';
import TaxProfile from '@/pages/TaxProfile/TaxProfile';
import Transactions from './pages/Transactions/Transactions';
import ArDashboard from './pages/ArDashboard/ArDashboard';
import InvestorReporting from './pages/InvestorReporting/InvestorReporting';
// eslint-disable-next-line max-len
import { InvestorReportsDetailsView } from './pages/InvestorReporting/InvestorReportsDetailsView';
import '@/css/App.css';

export default function Router() {
  return (
    <Routes>
      <Route key='sample' path='/sample' element={<APISample />} />
      <Route
        key='QBOAuthCallback'
        path='/QBOAuthCallback'
        element={<QBOAccessCallback />}
      />
      <Route path='/verify' element={<MagicLoginCallback />} />
      <Route
        path='/addNewInvestor'
        element={<MagicLoginCallback addInvestor />}
      />
      <Route key='referral' path='/referral/*' element={<Referral />} />
      <Route key='logout' path='/logout' element={<Logout />} />
      <Route key='login' path='/login/*' element={<Login />} />
      <Route key='mcp-auth' path='/mcp-auth' element={<McpAuth />} />
      <Route
        path='/home/*'
        element={
          <ProtectedRoute usersAllowed={['client']} allowImpersonation>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path='/i-home/*'
        element={
          <ProtectedRoute usersAllowed={['investor']}>
            <Home wipeImpersionation />
          </ProtectedRoute>
        }
      />
      <Route
        path='/i-files/*'
        element={
          <ProtectedRoute usersAllowed={['investor']}>
            <Files removeImpersonatingAccountIdForInvestors />
          </ProtectedRoute>
        }
      />
      <Route
        path='/i-account/*'
        element={
          <ProtectedRoute usersAllowed={['investor']}>
            <AccountInvestor />
          </ProtectedRoute>
        }
      />
      <Route
        path='/i-reporting/'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <InvestorReporting removeImpersonatingAccountIdForInvestors />
          </ProtectedRoute>
        }
      />
      <Route
        path='/i-reporting-details/*'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <InvestorReportsDetailsView
              removeImpersonatingAccountIdForInvestors
            />
          </ProtectedRoute>
        }
      />
      <Route
        path='/files'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <Files />
          </ProtectedRoute>
        }
      />
      <Route
        path='/files/*'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <Files />
          </ProtectedRoute>
        }
      />
      <Route
        path='/calendar'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <Files />
          </ProtectedRoute>
        }
      />
      <Route
        path='/custom-tab-option/*'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <CustomTabUrl />
          </ProtectedRoute>
        }
      />
      <Route
        path='/clients'
        element={
          <ProtectedRoute usersAllowed={validAdminsRoles}>
            <ClientList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/clients/:clientId/:tab'
        element={
          <ProtectedRoute usersAllowed={validAdminsRoles}>
            <ClientList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/categorizations'
        element={
          <ProtectedRoute
            usersAllowed={[...validAdminsRoles, 'client']}
            notAllowedUsers={['investor']}
          >
            <Transactions />
          </ProtectedRoute>
        }
      />
      <Route
        path='/tax-profile'
        element={
          <ProtectedRoute usersAllowed={validAdminsRoles}>
            <TaxProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path='/ar-dashboard'
        element={
          // <ProtectedRoute usersAllowed={[...validAdminsRoles, 'client']}> SC-3397: first iteration only allowed admin roles for AR snapshot access
          <ProtectedRoute usersAllowed={[...validAdminsRoles]}>
            <ArDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path='/marketplace'
        element={
          <ProtectedRoute
            usersAllowed={[...validAdminsRoles, 'client']}
            notAllowedUsers={['investor']}
          >
            <MarketPlace />
          </ProtectedRoute>
        }
      />
      <Route
        path='/users'
        element={
          <ProtectedRoute usersAllowed={['superadmin']}>
            <UsersList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/settings'
        element={
          <ProtectedRoute usersAllowed={['superadmin']}>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path='/users/:userId/:tab'
        element={
          <ProtectedRoute usersAllowed={validSuperAndSpecialAdminsRoles}>
            <UsersList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/firms/:firmId/:tab'
        element={
          <ProtectedRoute usersAllowed={validSuperAndSpecialAdminsRoles}>
            <UsersList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/account'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <MyAccount />
          </ProtectedRoute>
        }
      />
      <Route
        path='/account/:clientId/:type/:entityIdParam'
        element={
          <ProtectedRoute usersAllowed={[...validAdminsRoles, 'client']}>
            <MyAccount />
          </ProtectedRoute>
        }
      />
      <Route
        path='/faq'
        element={
          <ProtectedRoute usersAllowed={['client']} allowImpersonation>
            <FAQPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/taskpane-link'
        element={
          <ProtectedRoute usersAllowed={[]}>
            <TaskpaneLink />
          </ProtectedRoute>
        }
      />
      <Route path='*' element={<NavigateToDefaultPath />} />
    </Routes>
  );
}
